import VueAvatar from './components/VueAvatar.vue';
import VueAvatarEditor from './components/VueAvatarEditor.vue';
export default VueAvatarEditor;

export { VueAvatar, VueAvatarEditor };


//////////////////
// WEBPACK FOOTER
// ./~/vue-avatar-editor-improved/src/index.js
// module id = 945
// module chunks = 2 4 5